import Hero from './components/Hero';
import BrandIntro from './components/BrandIntro';
import OurStory from './components/OurStory';
import FeaturedCollection from './components/FeaturedCollection';
import MotionUniverse from './components/MotionUniverse';
import SignaturePieces from './components/SignaturePieces';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import CartDrawer from './components/CartDrawer';
import { useSEO } from '../../hooks/useSEO';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Motion Boyz | Luxury Streetwear – Motion Never Stops',
    description: 'Motion Boyz is luxury streetwear for those who never stop moving. Shop exclusive hoodies, denim sets, and signature pieces. Urban nightlife energy meets high-end fashion.',
    canonical: '/',
    ogImage: `${siteUrl}/og-image.jpg`,
    ogType: 'website',
    jsonLd: [
      {
        '@type': 'WebSite',
        name: 'Motion Boyz',
        url: siteUrl,
        description: 'Luxury streetwear brand – Motion Never Stops',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${siteUrl}/shop?q={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        name: 'Motion Boyz',
        url: siteUrl,
        logo: `${siteUrl}/logo.png`,
        description: 'Luxury streetwear brand redefining urban fashion with exclusive collections',
        sameAs: [
          'https://www.instagram.com/motionboyz',
          'https://www.facebook.com/motionboyz',
          'https://twitter.com/motionboyz',
        ],
      },
      {
        '@type': 'ClothingStore',
        name: 'Motion Boyz',
        url: siteUrl,
        description: 'Luxury streetwear – exclusive hoodies, denim sets, and signature pieces.',
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Motion Boyz Collection',
          url: `${siteUrl}/shop`,
        },
      },
    ],
  });

  return (
    <div className="bg-black min-h-screen overflow-x-hidden">
      <Navbar />
      <CartDrawer />
      <Hero />
      <BrandIntro />
      <div id="our-story">
        <OurStory />
      </div>
      <div id="collection">
        <FeaturedCollection />
      </div>
      <div id="universe">
        <MotionUniverse />
      </div>
      <div id="signature">
        <SignaturePieces />
      </div>
      <div id="community">
        <Newsletter />
      </div>
      <Footer />
    </div>
  );
}